import React from "react";
import { Button } from "@/aible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
const SortingHeaderCell = ({ column, text }) => {
    const sortedType = column.getIsSorted();
    return (React.createElement(Button, { type: "transparent", style: { color: "inherit", whiteSpace: "unset", padding: 0 }, onClick: () => column.toggleSorting() },
        text,
        sortedType === "asc" && React.createElement(FontAwesomeIcon, { icon: faSortUp }),
        sortedType === "desc" && React.createElement(FontAwesomeIcon, { icon: faSortDown })));
};
export default SortingHeaderCell;
